































































































import ThgVehicleCard from "@/components/thg/ThgVehicleCard.vue";
import Debug from "@/components/utility/Debug.vue";
import LayoutReport from "@/layouts/LayoutReport.vue";
import { UserModule } from "@/store/modules/user.store";
import { Component, Vue } from "vue-property-decorator";
import { FeatureModule } from "@/store/modules/feature.store";
import { NotificationModule } from "@/store/modules/notification.store";
import { getDefaultPartnerColor } from "@/lib/getDefaultPartnerColor";

@Component({
  components: {
    ThgVehicleCard,
    LayoutReport,
    Debug
  }
})
export default class ThgOverview extends Vue {
  isLoading = false;

  get isNotification() {
    return NotificationModule.isNotification;
  }

  get notifications() {
    return NotificationModule.notifications;
  }

  closeNotification(index: number) {
    NotificationModule.popNotification(index);
  }

  get isAuthenticated(): boolean {
    return UserModule.isAuthenticated;
  }

  get partnerColor() {
    return getDefaultPartnerColor();
  }

  get title() {
    return "Hallo " + UserModule.user.firstName + " ☀️";
  }

  get description() {
    return "Schön, dass du hier bist!";
  }

  get isInviteFriendsEnabled() {
    return FeatureModule.isInviteFriendsEnabled;
  }

  newCar() {
    this.$router.push({ path: "/thghome" });
  }

  vehicleOvervie() {
    this.$router.push({ name: "ThgVehicleOverview" });
  }

  toProfile() {
    this.$router.push({ name: "Profile" });
  }

  inviteFriends() {
    this.$router.push({ name: "ThgInviteFriends" });
  }

  toBillings() {
    this.$router.push({ name: "ThgBillingOverview" });
  }
}
